/**
 * Helpers for the pantry photo-capture flow (issue #488).
 *
 * `inventory-camera` and `recognition-results` are registered as hidden tab
 * screens (app/(app)/_layout.tsx). React Navigation keeps tab screens MOUNTED
 * after their first visit, so their local React state is not reset on re-entry.
 * Each screen must therefore detect when a *new* capture session begins and
 * reset the stale per-session state itself. A new session is identified by a
 * changed captured-image URI.
 */

/**
 * True when a freshly captured image has arrived and stale state from the
 * previous capture must be reset. A missing/unchanged URI needs no reset.
 */
export function shouldResetForNewImage(
  previousImageUri: string | null | undefined,
  nextImageUri: string | null | undefined,
): boolean {
  return !!nextImageUri && nextImageUri !== previousImageUri;
}
